import MediaQuery from '../../js/lib/mediaQuery';
import showTagList from '../../js/lib/showTagList';

var ul = document.getElementById('breadcrumbs');
if (window.matchMedia("(max-width: 992px)").matches) {
	showTagList(ul, 1, 2);
}

var tags = document.getElementsByClassName('tag__list');
for (var x = 0; x < tags.length; x++) 
	showTagList(tags[x], 4, 0, "result__tag");


//if (footerElement) {
//	const footerToggle = document.querySelectorAll('.js-footer-toggle');
//	const closeFooterLists = () => {
//		for (var i = 0; i < footerToggle.length; i++) {
//			footerToggle[i].removeAttribute('open');
//		}
//	}

//	const toggleFooterList = (event) => {
//		let listToToggle = event.currentTarget;
//		if (!listToToggle.getAttribute('open')) {
//			closeFooterLists();
//			listToToggle.setAttribute('open', true);
//		} else {
//			closeFooterLists();
//		}
//	}

//	// Only if Mobile
//	const mediaQuery = new MediaQuery(function() {
//		for (var i = 0; i < footerToggle.length; i++) {
//			footerToggle[i].addEventListener('click', () => {
//				toggleFooterList(event);
//			});
//		}
//	}, 'mobile')
//	mediaQuery()

//	var uc = true
//	window.addEventListener("resize", ()=>{mediaQuery()});

//}



// WEBPACK FOOTER //
// ../components/show-list/show-list.js